/* tslint:disable:max-line-length */
import { DefaultMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type ExtendedMessages = {
    status: string
    redirectButtonText: string,
    redirectUrl: string,
    MedicalProfessionalInfoShared: string,
    NURSE: string,
    errorFraud: string,
    errorId: {
        noRemainingRewardCodes: string,
    },
    step: {
        personalInfo: {
            title: string,
            countries: {
                US: string,
            },
            locales: {
                'en-US': string,
                es: string,
            },
            requiredFields: string,
        },
        success: {
            title: string,
            subtitle: string,
            codeText: string,
            thanks: string,
        },
        docUpload: {
            title: string,
            subtitle: string,
        },
        pending: {
            title: string,
        },
    },
};

export const medicalMessagesES: DefaultMessages & SegmentSpecificMessages & ExtendedMessages = {
    birthDate: 'Fecha de nacimiento',
    branchOfService: 'Área de servicio',
    changeLanguage: 'Cambia el idioma',
    status: 'Estado',
    country: 'Country',
    redirectUrl: 'https://www.nike.com/us/es',
    countries: {
        AD: 'Andorra',
        AE: 'United Arab Emirates',
        AF: 'Afghanistan',
        AG: 'Antigua and Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Netherlands Antilles',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'American Samoa',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbaijan',
        BA: 'Bosnia-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brazil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Canada (exclues Québec)',
        CF: 'Central African Republic',
        CG: 'Congo',
        CH: 'Switzerland',
        CI: 'Ivory Coast (Cote D\'Ivoire)',
        CK: 'Cook Islands',
        CL: 'Chile',
        CM: 'Cameroon',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cape Verde',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DJ: 'Djibouti',
        DK: 'Denmark',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        EH: 'Western Sahara',
        ER: 'Eritrea',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Islands',
        FM: 'Micronesia',
        FO: 'Faroe Islands',
        FR: 'France',
        GA: 'Gabon',
        GB: 'United Kingdom',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'French Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Greenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (French)',
        GQ: 'Equatorial Guinea',
        GR: 'Greece',
        GS: 'South Georgia & South Sandwich Islands',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard and McDonald Islands',
        HN: 'Honduras',
        HR: 'Croatia',
        HT: 'Haiti',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Iceland',
        IT: 'Italy',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KH: 'Cambodia',
        KI: 'Kiribati',
        KM: 'Comoros',
        KN: 'Saint Kitts & Nevis Anguilla',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KY: 'Cayman Islands',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Lebanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MC: 'Monaco',
        MD: 'Moldavia',
        ME: 'Montenegro',
        MG: 'Madagascar',
        MH: 'Marshall Islands',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macau',
        MP: 'Northern Mariana Islands',
        MQ: 'Martinique (French)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'New Caledonia (French)',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesia (French)',
        PG: 'Papua New Guinea',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Poland',
        PM: 'Saint Pierre and Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion (French)',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russian Federation',
        RW: 'Rwanda',
        SA: 'Saudi Arabia',
        SB: 'Solomon Islands',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Sweden',
        SG: 'Singapore',
        SH: 'Saint Helena',
        SI: 'Slovenia',
        SK: 'Slovak Republic',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        ST: 'Saint Tome (Sao Tome) and Principe',
        SV: 'El Salvador',
        SY: 'Syria',
        SZ: 'Swaziland',
        TC: 'Turks and Caicos Islands',
        TD: 'Chad',
        TF: 'French Southern Territories',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkey',
        TT: 'Trinidad and Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'USA Minor Outlying Islands',
        US: 'United States',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatican City State',
        VC: 'Saint Vincent & Grenadines',
        VE: 'Venezuela',
        VG: 'Virgin Islands (British)',
        VI: 'Virgin Islands (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis and Futuna Islands',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'South Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    dateTime: {
        january: 'Enero',
        february: 'Febrero',
        march: 'Marzo',
        april: 'Abril',
        may: 'Mayo',
        june: 'Junio',
        july: 'Julio',
        august: 'Agosto',
        september: 'Septiembre',
        october: 'Octubre',
        november: 'Noviembre',
        december: 'Diciembre',
        month: 'Mes',
        day: 'Día',
        year: 'Año',
        '20_MIN': '20 minutos',
        '2_HOURS': '2 horas',
        '24_HOURS': '24 horas',
        '3_DAY': '3 días',
        A_FEW_MINUTES: 'unos minutos',
        A_FEW_HOURS: 'unas horas',
        A_FEW_DAYS: 'unos días',
    },
    dischargeDate: 'Fecha de baja',
    emailAddress: 'Dirección de correo electrónico',
    emailExplanation: 'Personal email address is recommended',
    schoolName: '', // N/A
    phoneNumber: 'Número de celular de EUA*<span class="sid-field__label-explanation">Disponible solo para números de EUA</span>',
    error: 'Error',
    errorFraud: 'Se produjo un error',
    memberId: 'ID Number',
    optional: 'Opcional',
    limitExceededError: 'Límite de verificación excedido',
    redirectButtonText: 'CONTINÚA A NIKE',
    firstName: 'Nombre',
    howDoesReviewWork: '¿Cómo funciona la revisión?',
    howDoesVerifyingWork: '¿Cómo funciona la verificación?',
    informationTransferredToUS: 'Tu información se transferirá a los EE. UU. y se tratará de acuerdo con la Política de privacidad de SheerID.',
    lastName: 'Apellido',
    loading: 'Cargando...',
    locales: {
        ar: 'Arabic',
        bg: 'Bulgarian',
        cz: 'Czech',
        da: 'Danish',
        de: 'German',
        el: 'Greek',
        'en-GB': 'English (UK)',
        'en-US': 'Inglés',
        'es-ES': 'Spanish (Spain)',
        es: 'Español',
        fi: 'Finnish',
        'fr-CA': 'French (Canadian)',
        fr: 'French',
        hr: 'Croatian',
        hu: 'Hungarian',
        id: 'Indonesian',
        is: 'Icelandic',
        it: 'Italian',
        iw: 'Hebrew',
        ja: 'Japanese',
        ko: 'Korean',
        lt: 'Lithuanian',
        ms: 'Malay',
        nl: 'Dutch',
        no: 'Norwegian',
        pl: 'Polish',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        ro: 'Romanian',
        ru: 'Russia',
        sk: 'Slovak',
        sl: 'Slovenian',
        sr: 'Serbian',
        sv: 'Swedish',
        tr: 'Turkish',
        'zh-HK': 'Chinese (Hong Kong)',
        zh: 'Chinese (Traditional)',
    },
    militaryStatus: 'Estado militar',
    noOptions: 'Sin opciones',
    personalInformation: 'Información personal',
    personalOrSchoolIsFine: 'Personal or school email is fine',
    postalCode: 'Código postal',
    postalCodePlaceholder: 'Código postal',
    poweredBy: 'Servicios de verificación proporcionados por SheerID',
    requiredFields: 'Todos los campos son obligatorios',
    school: 'Escuela',
    sheeridFaqs: 'Preguntas frecuentes',
    studentInfoShared: "La información que se ingrese en este formulario web solo se usará con fines de verificación y mitigación de fraudes. Esta información está sujeta a los <a class='sid-link' href='http://agreementservice.svs.nike.com/rest/agreement?agreementType=termsOfUse&uxId=com.nike.unite&country=US&language=es&requestType=redirect' target='_blank'>Términos de uso</a> y la <a class='sid-link' href='http://agreementservice.svs.nike.com/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.commerce.nikedotcom.web&country=US&language=es&requestType=redirect' target='_blank'>Política de privacidad</a>.",
    universityName: 'Nombre de la universidad',
    verifyAndContinue: 'Verificar y continuar',
    verificationPurposesOnly: 'Solo se utilizará para fines de verificación',
    verifyMyStudentStatus: 'VERIFICAR Y CONTINUAR',
    verifyMyTeacherStatus: 'Verify My Teacher Status',
    verifyMyMilitaryStatus: 'Verificar mi estado militar',
    verifyMyMedicalProfessionalStatus: 'VERIFICAR Y CONTINUAR',
    verifyMyEmploymentStatus: 'Verify My Employee Status',
    verifyMyMembershipStatus: 'Verify My Membership Status',
    VETERAN: 'Veterano',
    MILITARY_RETIREE: 'Jubilado militar',
    RESERVIST: 'Reservista',
    ACTIVE_DUTY: 'Servicio activo',
    MILITARY_FAMILY: 'Dependiente militar registrado',
    FIREFIGHTER: 'Firefighter',
    POLICE: 'Law Enforcement',
    EMT: 'EMT',
    NURSE: 'Enfermero',
    DOCTOR: 'Doctor',
    OTHER_HEALTH_WORKER: 'Otro trabajador de la salud',
    organization: 'Área de servicio',
    verifyMyFirstResponderStatus: 'Verify My First Responder Status',
    firstResponderInfoShared: 'La información que se ingrese aquí se utilizará para fines de verificación',
    MedicalProfessionalInfoShared: "La información que se ingrese en este formulario web solo se usará con fines de verificación y mitigación de fraudes. Esta información está sujeta a los <a class='sid-link' href='https://agreementservice.svs.nike.com/rest/agreement?agreementType=termsOfUse&uxId=default&country=US&language=es&requestType=redirect' target='_blank'>Términos de uso</a> and <a class='sid-link' href='http://agreementservice.svs.nike.com/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.commerce.nikedotcom.web&country=US&language=es&requestType=redirect' target='_blank'>Política de privacidad</a>.",
    tryAgain: 'Vuelve a intentarlo',
    errorId: {
        docReviewLimitExceeded: 'Límite de revisión de documentos excedido',
        noRemainingRewardCodes: 'Lo sentimos, esta oferta está cerrada y no podemos verificarte en este momento. Por favor inténtalo de nuevo más tarde.',
        expiredProgram: 'Este enlace ya no está activo',
        futureBirthDate: 'Fecha de nacimiento futura',
        fraudRulesReject: `<span class="sid-error-fraud">No podemos verificar tu identidad con la información que proporcionaste. Comprueba lo que se estipula a continuación e inténtalo de nuevo.<br>
        <ul class="sid-error-fraud__list">
            <li>Puedes recibir correos en tu dirección de correo electrónico</li>
            <li>Puedes recibir mensajes de texto SMS en tu número de celular</li>
            <li>Utilizas tu propio teléfono o computadora y no un dispositivo compartido</li>
        </ul><br></span>
        <span class="sid-error-fraud-footer">¿Aún tienes problemas? <a href="https://verify.sheerid.com/verification-support/feedback.html?token=&locale=en_US&pid={programId}" class="sid-link">Contacta al equipo de ayuda de SheerID</a> para confirmar tu identidad.</span>`,
        internalServerError: 'Error interno del servidor',
        invalidApiToken: 'El token de la API suministrado no es válido o está vacío',
        invalidBirthDate: 'Fecha de nacimiento no válida',
        invalidDocUploadToken: 'El token de carga del documento suministrado no es válido',
        invalidEmail: 'Correo electrónico no válido',
        invalidCountry: 'Invalid country',
        invalidPhoneNumber: 'Número de celular no válido',
        invalidFileSizeEmpty: 'Uno o más campos está(n) vacío(s)',
        invalidFileSizeMax: 'Uno o más campos contiene(n) demasiados caracteres (máx.: 10MB)',
        invalidFirstName: 'Nombre no válido',
        invalidLastName: 'Apellido no válido',
        invalidMemberId: 'Invalid member ID',
        invalidNumberOfFiles: 'Número máximo de archivos excedido (máx.: 5)',
        invalidOrganization: 'Debes seleccionar una organización de la lista',
        noProgram: 'Programa no encontrado',
        noVerification: 'Verificación no encontrada',
        invalidProgram: 'Programa no válido',
        invalidStep: 'Paso no válido',
        invalidMilitaryStatus: 'Invalid military status',
        invalidFirstResponderStatus: 'Estado de miembro de los servicios de emergencia no válido',
        invalidPostalCode: 'Código postal no válido',
        underagePerson: 'Las personas menores de 16 años no son elegibles para esta oferta.',
        outsideAgePerson: 'Edad fuera del rango permitido',
        unsupportedDocMimeType: 'Uno o más archivos no tiene(n) un formato compatible',
        verificationLimitExceeded: 'Nos alegra saber que eres entusiasta, pero parece que ya has canjeado o has intentado canjear esta oferta.',
        apiRateLimitExceeded: 'No hemos podido procesar tu solicitud en este momento, inténtalo de nuevo más tarde.',
        maxMetadataValuesExceeded: 'Número máximo de valores de metadata excedido',
        maxMetadataLengthExceeded: 'Longitud máxima de valores de metadata excedida',
        unknownError: 'Error desconocido',
        invalidRequest: 'Error desconocido',
        notFound: 'No se encontró',
        unauthorizedDomain: 'No se encontró',
    },
    step: {
        personalInfo: {
            title: 'VERIFICA TU INFORMACIÓN',
            subtitle: 'Confirma que cumples con los requisitos completando el siguiente formulario para esta oferta de descuento destinada a miembros activos de los servicios de emergencia.',
            countries: {
                US: 'United States',
            },
            locales: {
                'en-US': 'Inglés',
                es: 'Español',
            },
            requiredFields: 'Todos los campos son obligatoriosTodos los campos son obligatorios',
            howDoesVerifyingWorkDetails: 'Confirma tu elegibilidad completando el formulario a continuación para esta oferta especial de descuento para miembros del servicio militar.',
            tryAgain: {
                title: 'Comprueba tu nombre y fecha de nacimiento',
                subtitle: 'Esta oferta está disponible para personal militar que ha prestado servicio o que actualmente presta servicio en las Fuerzas Armadas de los EE. UU.<br><br>Nike usa SheerID, un socio confiable, para verificar que eres miembro del servicio militar. SheerID solo recolecta información que ayuda a verificar tu elegibilidad. Es posible que se solicite información o documentación adicional.',
            },
        },
        docUpload: {
            title: 'NECESITAMOS TU DOCUMENTO DE IDENTIFICACIÓN',
            subtitle: 'Los documentos están siendo revisados ​​por el personal de SheerID. Durante horas pico, la verificación puede demorar más de 3 horas.',
            acceptableUploadExamples: 'Estos son algunos ejemplos aceptables',
            acceptedTypes: 'El archivo debe tener formato .jpg .jpeg .png .pdf .gif o .bmp',
            addFile: 'Agregar archivo',
            cancelButtonLabel: 'Cancelar',
            fileInstructions: 'Arrastra y suelta tus archivos aquí o <span class="sid-dropzone-wrap--link">buscar</span>',
            footer: '',
            submitButtonLabel: 'ENVIAR PARA REVISIÓN',
            rejectedSubtitle: 'No pudimos confirmar tu elegibilidad debido a:',
            howDoesVerifyingWorkDetails: 'La revisión de la documentación es gestionada por SheerID, un socio de confianza que se especializa en verificar a los profesionales médicos. Los documentos se usan solo para verificar que tu estado de profesional médico sea actual y se eliminarán de forma permanente una vez que la revisión finalice. No se compartirán con Nike.',
            uploadInstructions: 'Sube un documento oficial que muestre lo siguiente:',
            rejectionReasons: {
                DOCUMENT_UNREADABLE: 'El documento que enviaste no era legible debido a una mala calidad de imagen. Asegúrate de tener una imagen claramente legible que sea brillante y nítida, y trata de enviarla de nuevo.',
                DOCUMENT_PASSWORD_PROTECTED: 'No podemos aceptar documentos protegidos con contraseña.',
                DOCUMENT_LIKELY_FRAUD: 'El documento que enviaste no es suficiente para establecer tu elegibilidad para esta oferta.',
                DOCUMENT_UNSUPPORTED: 'El documento que enviaste no está en la lista de tipos de documentos aceptados.',
                DOCUMENT_HANDWRITTEN: 'No podemos aceptar documentos manuscritos.',
                MISSING_INFORMATION: 'El documento que enviaste no proporciona toda la información necesaria para determinar tu elegibilidad para esta oferta.',
                MISSING_INFORMATION_PERSON_NAME: 'Al documento que enviaste le falta el nombre y/o el apellido.',
                MISSING_INFORMATION_ORGANIZATION_NAME: 'El documento que enviaste no incluye un nombre de organización que confirme tu conexión con dicha organización.',
                DOCUMENT_EXPIRED: 'El documento que enviaste ha vencido.',
                DOCUMENT_OUTDATED: 'Al documento que enviaste le falta una fecha de emisión o se emitió en una fecha muy antigua.',
                MISMATCH_PERSON_NAME: 'La información en el documento que enviaste no coincide con el nombre y/o el apellido enviado en el formulario de verificación.',
                MISMATCH_ORGANIZATION: 'El nombre de la organización en la documentación que enviaste no coincide con la organización descrita en el formulario de verificación.',
                MISMATCH_STATUS: 'El estado en el documento que enviaste no coincide con el estado descrito en el formulario de verificación.',
                INELIGIBLE_ORGANIZATION: 'El estado en el documento que enviaste no coincide con el estado descrito en el formulario de verificación.',
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT: 'El documento que enviaste no prueba la inscripción en el corriente cuatrimestre.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT: 'Los estudiantes de escuela secundaria no son elegibles para esta oferta.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES: 'El documento que enviaste no muestra una afiliación a un área elegible de las Fuerzas Armadas de los EE. UU.',
                MISMATCH_COMPANY_NAME_OR_ADDRESS: 'El nombre o la dirección de la empresa en tu documento no coincide con la información ingresada en el formulario de verificación.',
                PAYSTUB_OUTDATED_LAST_30_DAYS: 'Carga un recibo de pago emitido dentro de los últimos 30 días.',
                MISSING_INFORMATION_BIRTHDATE: 'Al documento que enviaste le falta una fecha de nacimiento, o tu edad no es elegible para esta oferta.',
                MISMATCH_BIRTHDATE: 'La fecha de nacimiento en el documento que enviaste no coincide con la fecha de nacimiento descrita en el formulario de verificación.',
                DOCUMENT_OUTDATED_FACULTY: 'El documento que enviaste no prueba el empleo en el corriente año académico.',
                MISSING_OR_MISMATCH_JOB_TITLE: 'Falta el puesto laboral en el documento que enviaste o este no coincide con la información ingresada en el formulario de verificación.',
                OTHER_CONTACT_US: 'Estamos teniendo problemas para verificar tu elegibilidad para esta oferta. Comunícate con el área de Atención al Cliente de SheerID para obtener ayuda: customerservice@sheerid.com',
                PERSON_FIELD_MISMATCH: 'Un campo en el documento proporcionado no coincide con la información provista en el formulario de verificación.',
            },
            uploadInfo: {
                fullName: 'Tu nombre completo',
                student: {
                    enrollmentDate: 'Date proving enrollment for the current term (or within the last 3 months)',
                    school: 'Your school',
                },
                teacher: {
                    currentSchoolYear: 'A date in the current school year',
                    school: 'Your school',
                },
                military: {
                    currentAffiliation: 'Your current affiliation with the armed services',
                    dischargeDate: 'Your discharge date (if applicable)',
                    serviceBranch: 'Your branch of service',
                    uploadInstructionsDependent: 'Please upload a document that clearly shows your first name, last name, valid dates and status',
                },
                senior: {
                    birthDate: 'Your date of birth',
                },
                age: {
                    birthDate: 'Your date of birth',
                },
                firstResponder: {
                    currentAffiliation: 'Your current affiliation with that organization',
                    organization: 'Your organization',
                },
                medical: {
                    status: 'Tu estado de profesional médico',
                    validDate: 'Una fecha válida actualmente',
                },
                employment: {
                    company: 'Your company',
                    currentAffiliation: 'Your current affiliation with that company',
                },
            },
            acceptableUploads: {
                student: {
                    idCard: 'School ID card with expiration date',
                    classSchedule: 'Class schedule',
                    tuitionReceipt: 'Tuition receipt',
                },
                teacher: {
                    idCard: 'Teacher ID card with valid date',
                    payStub: 'Pay stub from within last 60 days',
                },
                member: {
                    idCard: 'Membership Document',
                    payStub: 'Pay stub from within last 90 days',
                },
                senior: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                age: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                military: {
                    activeDuty: 'Any document that proves you are currently serving under Title 10 Active Duty Orders for 30 days or more',
                    veteran: 'Any document that proves you met the qualifications of military service and were honorably discharged',
                    reservistA: 'Any document that shows you are currently serving in the National Guard or a Reserve Component of The United States Armed Forces',
                    retiree: 'Any document that proves you are a Retiree from the US Armed Forces',
                    dependent: 'Any document that proves you are a Registered Military Dependent',
                },
                medical: {
                    licenseCertificate: 'Certificado de licencia',
                    idCard: 'Tarjeta de identificación de enfermero con fecha de vencimiento',
                    photoPayStub: 'Documento de identificación con fotografía y comprobante de pago reciente',
                },
                employment: {
                    employeeIdCard: 'Employee ID Card',
                    payStub: 'Pay stub from within last 60 days',
                    officialLetter: 'An official letter',
                },
            },
        },

        pending: {
            title: 'DOCUMENTACIÓN NECESARIA',
            subtitle: 'Los documentos están siendo revisados ​​por el personal de SheerID. Durante horas pico, la verificación puede demorar más de 3 horas.',
            subtitle2: 'Espere aquí o permítanos notificarle los resultados.',
            subtitle3: 'NOTA: Si no recibes un correo electrónico dentro del plazo establecido arriba, busca el mensaje en tu carpeta de correo no deseado.',
            titleCountdown: 'PROCESANDO',
            titleReview: 'DOCUMENTACIÓN NECESARIA',
            subtitleCountdown: 'Espera mientras subimos y escaneamos tus documentos.',
        },
        success: {
            title: '¡FELICITACIONES!',
            subtitle: "Ya te han verificado. A continuación encontrarás tú código promocional de un solo uso que podrás utilizar al finalizar la compra en <a class='sid-link' href='https://www.nike.com/us/es' target='_blank'>www.nike.com</a> o en la Nike App. Este código promocional vencerá en dos semanas. Durante la finalización de la compra, debes ingresar como <a class='sid-link' href='https://www.nike.com/us/es/membresia' target='_blank'>miembro de Nike</a> para canjearlo. El código no puede combinarse con ninguna otra oferta o promoción.",
            copyCouponCode: 'Copia tu código promocional',
            emailNotification: 'Te hemos enviado una copia por correo electrónico para que puedas usar tu nuevo código ahora o más adelante. Busca el correo electrónico de verify@sheerid.com.',
            verificationOnly: "Para asegurarte de tener cada oportunidad de usar tu descuento, también te enviamos este código promocional para que puedas comprar ahora o más adelante. Busca un correo electrónico de (verify@sheerid.com)  para obtener más información.",
            codeText: 'Código promocional:',
            thanks: 'Gracias por su servicio',
        },
        sso: {
            title: 'Verify using your school credentials',
            subtitle: "Please sign in to your school's web portal. It will open in a new tab.",
            subtitle2: "Can't sign in to your email?",
            login: 'Sign in to my school',
            cancel: 'Upload proof of employment',
        },
        smsLoop: {
            verificationCode: 'Código de verificación',
            incorrectNumber: {
                incorrectNumber1: 'Número incorrecto? ',
                incorrectNumber2: 'Haz clic aquí',
                incorrectNumber3: '.',
            },
            resendButton: 'Volver a enviar',
            submitButton: 'Enviar',
        },
    },
};
